module.exports = __webpack_public_path__ + "img/mobile-outline-black.a7171573.png";